import React, { useEffect } from "react";
import "./index.css";
import { Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../stores/store";
import {
  selectCollection,
  setPaginationModel,
  setFormData,
  clearCollections,
  setSortModel,
} from "../../stores/collection";
import BatchDataFilter from "../../components/BatchDataFilter";
import CollectionsTable from "../../components/DataTable/CollectionsTable";
import { useNavigate } from "react-router";
import { ROUTES } from "../../config/routes";
import { useWebServer } from "../../providers";
import { CollectionsFormData } from "../../types";
import { fetchCollections } from "../../stores/collection/actions";
import { fetchDevices } from "../../stores/devices/actions";
import { fetchTrapTypes } from "../../stores/collectionSites/actions";
import { fetchCollectionSites } from "../../stores/collectionSites/actions";
import { Collection } from "../../types";

const Collections: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { sendRequest } = useWebServer();

  const collections = useAppSelector((state) => state.collections.collections);
  const status = useAppSelector((state) => state.collections.status);
  const paginationModel = useAppSelector(
    (state) => state.collections.paginationModel
  );
  const formData = useAppSelector((state) => state.collections.formData);
  const collectionCount = useAppSelector((state) => state.collections.count);
  const trapSiteOptions = useAppSelector(
    (state) => state.collectionSites.collectionSites
  );
  const trapTypeOptions = useAppSelector(
    (state) => state.collectionSites.trapTypes
  );

  const handleSelectCollection = (id: string) => {
    dispatch(selectCollection(id));
    navigate(ROUTES.COLLECTION);
  };

  const handleSubmit = (formData: CollectionsFormData) => {
    dispatch(fetchCollections({ sendRequest, filters: formData }));
  };

  const handleUpdateFormData = (
    newFormData: CollectionsFormData,
    init: boolean = false
  ) => {
    if ((collections.length > 0 && init) || paginationModel.pageSize === -1) {
      return;
    }
    const pagination = { page: 0, pageSize: paginationModel.pageSize };
    dispatch(setPaginationModel(pagination));
    setFormData(newFormData);
    handleSubmit({ ...newFormData, ...paginationModel });
    handleSubmit({
      ...newFormData,
      page: 1,
      pageSize: paginationModel.pageSize,
    });
  };

  const handleUpdatePagination = (pagination: {
    page: number;
    pageSize: number;
  }) => {
    const fetchedPage = collections.length / paginationModel.pageSize - 1;

    dispatch(setPaginationModel(pagination));

    if (pagination.page === 0) {
      dispatch(clearCollections());
      handleSubmit({
        ...formData,
        page: pagination.page,
        pageSize: pagination.pageSize,
      });
      handleSubmit({
        ...formData,
        page: pagination.page + 1,
        pageSize: pagination.pageSize,
      });
    } else if (
      pagination.page + 1 >= fetchedPage &&
      collections.length < collectionCount
    ) {
      handleSubmit({
        ...formData,
        page: pagination.page + 1,
        pageSize: pagination.pageSize,
      });
    }
  };

  const handleSetSortModel = (
    order: "desc" | "asc",
    orderBy: keyof Collection
  ) => {
    dispatch(setSortModel({ order, orderBy }));
  };

  useEffect(() => {
    dispatch(fetchCollectionSites(sendRequest));
    dispatch(fetchTrapTypes(sendRequest));
    dispatch(fetchDevices(sendRequest));
  }, [dispatch, sendRequest]);

  return (
    <div className="batchGallery">
      <Grid container>
        <Grid size={12}>
          <BatchDataFilter handleSubmit={handleUpdateFormData} />
        </Grid>
        <Grid size={12}></Grid>
        <CollectionsTable
          setSortModel={handleSetSortModel}
          loading={status === "loading"}
          collections={collections}
          collectionCount={collectionCount}
          paginationModel={paginationModel}
          setPaginationModel={handleUpdatePagination}
          handleSelectCollection={handleSelectCollection}
          trapSiteOptions={trapSiteOptions}
          trapTypeOptions={trapTypeOptions}
        />
      </Grid>
    </div>
  );
};

export default Collections;
